import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const InstitutionResponsibleNameInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Responsable de la institución">
      {getFieldDecorator("institutionResponsibleName", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el nombre del responsable de la institución."
          }
        ],
        initialValue: implementerProfile?.institutionResponsibleName
      })(
        <Input
          disabled={isBusy}
          id="institutionResponsibleName"
          name="institutionResponsibleName"
          placeholder="Responsable de la institución"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
